'use strict'

const { twoFactorSelected } = require('./app-two-factor')
const { embedAppPath, stayInsideEmbed } = require('./embed')

// Client-side submission redirects. A form, a login view, and a registration
// view use these paths. Record writes stay on the server.

const REDIRECT_TYPES = {
  redirect_parent: true,
  redirect_page: true,
  redirect_child: true
}

function submissionRedirectPath (action, route) {

  if (!action || !REDIRECT_TYPES[action.type]) return null

  const application = (route && route.application) || ''
  const path = (route && route.path) || ''
  const segments = path.split('/').filter(Boolean)

  if (action.type === 'redirect_parent') {

    if (segments.length <= 1) return null

    segments.pop()

    if (route && route.accessKey) segments.pop()

    return keepEmbedPath('/' + segments.join('/'), route)
  }

  if (!action.pageUniqueTitle) return null

  if (action.type === 'redirect_child' && action.autoCreate) {

    const base = path.replace(/\/$/, '')
    const linkId = route && route.linkId

    if (linkId) return keepEmbedPath(`${base}/${action.pageUniqueTitle}/${linkId}`, route)

    return keepEmbedPath(`${base}/${action.pageUniqueTitle}`, route)
  }

  return keepEmbedPath(`/${application}/${action.pageUniqueTitle}`, route)
}

function keepEmbedPath (path, route) {

  if (!path || !route || !route.embed || !route.embed.mode) return path

  const from = embedAppPath({
    application: route.application,
    mode: route.embed.mode,
    pageUniqueTitle: 'current',
    viewUniqueTitle: route.embed.viewUniqueTitle || 'view'
  })

  return stayInsideEmbed(from, path) || path
}

function firstSubmissionRedirect (actions, route) {

  if (!Array.isArray(actions)) return null

  for (const action of actions) {

    if (!action || !REDIRECT_TYPES[action.type]) continue

    return submissionRedirectPath(action, route)
  }

  return null
}

function copySubmissionConfig (target, component) {

  if (!target || !component) return
  if (component.type !== 'form' && component.type !== 'login' && component.type !== 'registration') return

  target.submissionRules = component.submissionRules || null

  if (component.type === 'login' || component.type === 'registration') {

    target.twoFactorValue = twoFactorSelected(component)
  }

  if (component.type !== 'form') return

  target.defaultValueRules = component.defaultValueRules || null
  target.formActions = component.formActions || null
}

module.exports = {
  submissionRedirectPath,
  firstSubmissionRedirect,
  copySubmissionConfig
}
